module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/componentes/novedades/novedades.component.scss
// module id = ./src/app/componentes/novedades/novedades.component.scss
// module chunks = main